import React, { ReactNode } from 'react'

import { clsx } from 'clsx'

import type { Image } from '@tribeplatform/gql-client/types'
import { MediaZoom } from '@tribeplatform/react-ui-kit/MediaZoom'

import { useI18n } from '../../i18n/providers/I18nProvider.js'
import { BannerContent } from './BannerContent.js'

interface BannerProps {
  banner: Image
  fallback?: ReactNode
  zoom?: boolean
  className?: string
}
export const Banner = ({
  banner,
  zoom = false,
  fallback,
  className,
}: BannerProps) => {
  const { $t } = useI18n()

  if (!banner) {
    return (
      <div className={clsx('w-full overflow-hidden', className)}>
        {fallback}
      </div>
    )
  }

  if (!zoom) {
    return <BannerContent banner={banner} className={className} />
  }

  return (
    <MediaZoom zoom>
      <MediaZoom.Item
        item={{
          id: banner.id,
          thumbnail: banner.urls?.large,
          original: banner.urls?.large,
          alt: $t({ id: 'Generics.Cover', defaultMessage: 'Cover' }),
        }}
      >
        {({ open }) => (
          <button
            type="button"
            onClick={open}
            className="w-full block"
            aria-label={$t({ id: 'Generics.Cover', defaultMessage: 'Cover' })}
          >
            <BannerContent banner={banner} className={className} />
          </button>
        )}
      </MediaZoom.Item>
    </MediaZoom>
  )
}
